export default __webpack_public_path__ + "static/2-9c119436728600e29c86065f9407bb2e.png";